var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookMark3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.7999C6 4.16338 6.25286 3.55293 6.70294 3.10285C7.15303 2.65276 7.76348 2.3999 8.4 2.3999H15.6C16.2365 2.3999 16.847 2.65276 17.2971 3.10285C17.7471 3.55293 18 4.16338 18 4.7999V21.5999L12 18.5999L6 21.5999V4.7999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMark3);
export default __webpack_public_path__ + "static/media/book_mark_3.ca2addf1c5e968d720c3161f5f34b2ce.svg";
export { ForwardRef as ReactComponent };